<template>
    <b-modal ref="promptmodal" :centered="true" :lazy="true" title="Are you sure?" no-fade>
        <div class="prompt-text">
            Are you sure you want to proceed with this?
        </div>

        <div slot="modal-footer" class="w-100">
            <div class="float-right">
                <b-btn variant="flat" @click="close()">
                    No! Don't.
                </b-btn>
                <b-btn variant="primary" @click="ok()">
                    Yes! Go ahead.
                </b-btn>
            </div>
        </div>
    </b-modal>
</template>

<script>
export default {
  name: "promptmodal",
  props: ["action", "args"],
  methods: {
    close() {
      this.$refs.promptmodal.hide();
    },
    ok() {
      this.action(this.args);
      this.$refs.promptmodal.hide();
    }
  }
};
</script>

<style>

</style>
